import React from "react";
import {Dropdown} from 'antd';
import SAInput from '../common/input/SAInput';
import {injectIntl} from "react-intl";
import './LabelEncoder.css'

class LabelEncoder extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.values);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.values) {
      this.setState({label: nextProps.values})
    }
  }

  getInitialState = (values) => {
    const initialState = {
      label: values || {},
      visible: false,
    };
    return initialState;
  }

  resetState = () => {
    this.setState(this.getInitialState());
  }

  onSave = (e) => {
    const {intl: {formatMessage}, keys, mandatory} = this.props;
    const {label} = this.state;

    const errors = {};

    if (mandatory !== false || !keys.every(key => !label[key])) {
      keys.forEach(key => {
        if (!label[key]) {
          errors[key] = {message: formatMessage({id: 'error.not.null'})};
        }
      })
    }

    this.setState({errors: errors});

    if (Object.keys(errors).length === 0) {
      this.setState({visible: false});
      label.id = this.props.labelId;
      this.props.onValidate(this.state.label);
      this.resetState();
    }
  }

  onInputChange = (e) => {
    const {label} = this.state;
    label[e.target.name] = e.target.value
    this.setState({label});
  }

  onCancel = (e) => {
    this.setState({visible: false});

  }

  handleVisibleChange = (flag) => {
    this.setState({visible: flag});
  }

  render() {

    const {intl: {formatMessage}, keys, className} = this.props;

    const inputs = [];
    keys.forEach(key => {
      inputs.push(<li key={key}>
        <span>
        <label htmlFor={key}>{formatMessage({id: key})}</label>
        <SAInput onChange={this.onInputChange} value={this.state.label[key]} id={key} name={key}
                 error={this.state && this.state.errors && this.state.errors[key]}/>
        </span>
        </li>
      )
    });

    const overlay = (
      <div className="dropdown dropdown--md dropdown--bottom-left">
        <ul className="list">
          {inputs.map(input => {
            return input;
          })}
        </ul>
        <br/>
        <div className="ant-table-filter-dropdown-btns">
          <a onClick={this.onSave}
             className="ant-table-filter-dropdown-link confirm">{formatMessage({id: 'action.add'})}</a>
          <a onClick={this.onCancel}
             className="ant-table-filter-dropdown-link clear">{formatMessage({id: 'action.cancel'})}</a>
        </div>
      </div>)


    return (
      <div className={"dropdown-wrapper " + (className || '')}>
        <Dropdown overlay={overlay} trigger={['click']}
                  onVisibleChange={this.handleVisibleChange}
                  visible={this.state.visible}
        >
          {this.props.children}
        </Dropdown>


      </div>
    )
  }
}

export default injectIntl(LabelEncoder);
